import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {BaseResponse} from "../../../../../common/interfaces/global-interfaces";
import {GraphqlService} from "../../../../../services/graphql.service";
import {GET_ALL_IN_APP_NOTIFICATION, InAppNotification, VIEW_IN_APP_NOTIFICATION} from "./notification-list";
import {Router} from "@angular/router";
import {NotificationService} from "../../../../../services/notification.service";


@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
})
export class NotificationListComponent implements OnInit{

  private apollo: GraphqlService = inject(GraphqlService)
  private notificationService: NotificationService = inject(NotificationService)
  private router: Router = inject(Router)

  @Output() totalNotifications = new EventEmitter();

  inAppNotifications: InAppNotification[] = [];
  pageObject: any

  async ngOnInit() {
    console.log('init')

    await this.loadData();

  }

  async loadData(pageNumber: number = 1) {
    try {
      const response = await this.apollo.query({
        query: GET_ALL_IN_APP_NOTIFICATION,
        variables: {
          filtering: {
            pageNumber,
            itemsPerPage: 6
          }
        }
      });

      const result: BaseResponse<InAppNotification[]> = Object.values(Object.values(response)[0])[0];
      if (result.response.status) {
        this.inAppNotifications = result?.data;
        this.pageObject = result?.page;
        this.totalNotifications.emit(this.pageObject?.totalElements)
      } else {
        throw new Error("Operation Failed")
      }
    } catch (error) {
      this.notificationService.errorMessage(error?.message)
    }
  }

  async openNotification(inAppNotification: InAppNotification) {
    this.router.navigate(
      ['','manage','complaints-management','all-complaints'],
      { queryParams: { action: 'view', id: inAppNotification?.relatedUuid } }
    );

    try {
      const response = await this.apollo.mutate({
        mutation: VIEW_IN_APP_NOTIFICATION,
        variables: {
          uniqueId: inAppNotification?.uniqueId
        }
      });

      const result: BaseResponse<any> = Object.values(Object.values(response)[0])[0];
      if (result.response.status) {
        await this.loadData(this.pageObject?.currentPageNumber)
      } else {
        throw new Error("Operation Failed")
      }
    } catch (error) {
      this.notificationService.errorMessage(error?.message)
    }

  }
}
